import { createPaneContext } from '@trimble/pane-layout';
import type { PaneContextState as GenericPaneContextState } from '@trimble/pane-layout';
import { ViewMode } from '@mobile-mapping/web3d';
import { PERSISTENCE_KEY } from './constants/make-persisted-constants';
import { PANE_LAYOUT } from './constants/pane-layout-constants';

export type PaneContextState = GenericPaneContextState<ViewMode>;

const { PaneContextProvider, usePaneContext } = createPaneContext<ViewMode>({
  defaultLayouts: PANE_LAYOUT,
  persistenceKey: PERSISTENCE_KEY.PaneLayout,
});

export { PaneContextProvider, usePaneContext };
